<template>
  <div>
    <p>For customers unable to use the DMV portal or unable to receive their OTP.</p>
    <p><a href="https://www.ri.gov/DMV/registration_renewal/" target="_blank" rel="noopener noreferrer">Registration Renewal</a></p>
    <p><a href="https://www.ri.gov/DMV/duplicate_registration/" target="_blank" rel="noopener noreferrer">Duplicate Registration</a></p>
    <BaseButtonGroup>
      <button type="button" @click="goBack()">Previous</button>
    </BaseButtonGroup>
  </div>
</template>

<script setup>
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import BaseButtonGroup from '@/components/ui/BaseButtonGroup.vue';

const store = useStore();
const router = useRouter();
const route = useRoute();

const goBack = () => {
  const previousStep = Number(route.query.from);
  store.commit('guestLogin/setState', { property: 'mfaStep', value: previousStep });
  router.push({ name: 'MultiFactAuth' });
};
</script>